module.exports = __webpack_public_path__ + "img/new_27.1addb153.jpg";